/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftGeneratorControllerDtoAddNftKeyIndexRequest model module.
 * @module model/NftGeneratorControllerDtoAddNftKeyIndexRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoAddNftKeyIndexRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoAddNftKeyIndexRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoAddNftKeyIndexRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoAddNftKeyIndexRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoAddNftKeyIndexRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoAddNftKeyIndexRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoAddNftKeyIndexRequest} The populated <code>NftGeneratorControllerDtoAddNftKeyIndexRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoAddNftKeyIndexRequest();

            if (data.hasOwnProperty('shape')) {
                obj['shape'] = ApiClient.convertToType(data['shape'], 'String');
            }
            if (data.hasOwnProperty('index')) {
                obj['index'] = ApiClient.convertToType(data['index'], 'Number');
            }
            if (data.hasOwnProperty('prime')) {
                obj['prime'] = ApiClient.convertToType(data['prime'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoAddNftKeyIndexRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoAddNftKeyIndexRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['shape'] && !(typeof data['shape'] === 'string' || data['shape'] instanceof String)) {
            throw new Error("Expected the field `shape` to be a primitive type in the JSON string but got " + data['shape']);
        }

        return true;
    }


}



/**
 * @member {String} shape
 */
NftGeneratorControllerDtoAddNftKeyIndexRequest.prototype['shape'] = undefined;

/**
 * @member {Number} index
 */
NftGeneratorControllerDtoAddNftKeyIndexRequest.prototype['index'] = undefined;

/**
 * @member {Number} prime
 */
NftGeneratorControllerDtoAddNftKeyIndexRequest.prototype['prime'] = undefined;






export default NftGeneratorControllerDtoAddNftKeyIndexRequest;

